
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    items: require("@/data/novibet/bespokecrash.json"),
  }),
});
